export const fetchClients = data => ({
	type: 'CLIENTS_DATA',
	payload: data,
});
export const fetchAccounts = data => ({
	type: 'ACCOUNTS_DATA',
	payload: data,
});
export const fetchHierarchies = data => ({
	type: 'HIERARCHY_DATA',
	payload: data,
});
export const fetchBenchmarks = data => ({
	type: 'BENCHMARKS_DATA',
	payload: data,
});
export const fetchClientDimensions = data => ({
	type: 'CLIENT_DIMENSIONS_DATA',
	payload: data,
});
export const fetchMetrics = data => ({
	type: 'METRICS_DATA',
	payload: data.data.response,
});
export const selectDimension = data => ({
	type: 'SELECT_DIMENSION',
	payload: data,
});
export const reset_all_data = () => ({
	type: 'RESET_ALL_DATA',
});
export const selectMetrics = data => ({
	type: 'SELECT_METRIC',
	payload: data,
});
export const setShowLoader = loading => ({
	type: 'SHOW_LOADER',
	payload: loading,
});
export const updatePhoenixToken = token => ({
	type: 'UPDATE_TOKEN',
	payload: token,
});
export const updateXDEDimensions = token => ({
	type: 'UPDATE_XDE_DIMENSIONS',
	payload: token,
});
export const updateXDEDimensionsOrder = token => ({
	type: 'UPDATE_XDE_DIMENSIONS_ORDER',
	payload: token,
});
export const updateXDEMetrics = token => ({
	type: 'UPDATE_XDE_METRICS',
	payload: token,
});
export const updateXDEMetricsOrder = token => ({
	type: 'UPDATE_XDE_METRICS_ORDER',
	payload: token,
});